<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div
      v-if="busy" :key="busy"
      class="text-center"
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
      "
    >
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <b-row class="mx-0 mb-3">
      <b-col>
        <b-card class="shadow bg-light">
          <b-card-title title-tag="h6">
            Paiements
            <span v-if="resultsInfo">({{ resultsInfo }} résultats)</span>
          </b-card-title>
          <div class="d-flex justify-content-start align-items-center">
            <b-button
              icon
              :to="{ path: '/invoices-commissions' }"
              size="sm"
              title="Factures commissions"
              ><i class="fad fa-file-invoice"></i>
            </b-button>
            <label class="mx-3 align-self-center">Rechercher :</label>
            <mh-input
              append="🔍"
              field="search"
              :table="searchTable"
              autofocus
              :autocomplete="{
                field:
                  'debiteur.(nom prenom) || debiteur.nom_soc || creancier.(nom prenom) || creancier.nom_soc',
              }"
              @enter="submitSearch()"
            ></mh-input>
            <label class="mx-3 align-self-center">Status :</label>
            <mh-input
              field="status"
              :table="searchTable"
              @change="submitSearch()"
            ></mh-input>
          </div>
          <b-row v-if="$options.payments.length > 0" class="mt-3">
            <b-col lg="12">
              <list
                @changePage="changePage"
                @removeFilter="removeFilter"
                @changeSort="changeSort"
                :fields="fields"
                :search="search"
                :filters="filters"
                :items="$options.payments"
              >
                <template v-slot:info v-bind="total">
                  <h5>
                    <b-badge
                      >Total chez nous :
                      {{ Number(total.societe).toLocaleString() }} €</b-badge
                    >
                    <b-badge class="float-right"
                      >Total chez les créanciers :
                      {{ Number(total.creancier).toLocaleString() }} €</b-badge
                    >
                  </h5>
                  
                </template>

                <template v-slot:cell(mandatID)="data">
                  <router-link
                    :to="{
                      name: 'warrantEdit',
                      params: { id: data.item.mandatID },
                    }"
                    >{{ data.item.mandatID }}</router-link
                  >
                </template>
                <template v-slot:cell(debiteur)="data">
                  <div class="w-100 text-truncate">
                    <b-link
                      :to="{
                        name: 'debtorView',
                        params: { id: data.item.debiteurID },
                      }"
                    >
                      <span v-html="company(data.item.debiteur)"></span>
                    </b-link>
                  </div>
                </template>
                <template v-slot:cell(creancier)="data">
                  <div class="w-100 text-truncate">
                    <b-link
                      :to="{
                        name: 'creditorView',
                        params: { id: data.item.creancierID },
                      }"
                    >
                      <span v-html="company(data.item.creancier)"></span>
                    </b-link>
                  </div>
                </template>
                <template v-slot:cell(date)="data">{{
                  toDate(data.item.date)
                }}</template>
                <template v-slot:cell(date_encodage)="data">{{
                  toDate(data.item.date_encodage)
                }}</template>
                <template v-slot:cell(cheznous)="data">
                  <span v-if="data.item.reception == 'societe'"
                    >{{ data.item.montant }} €</span
                  >
                </template>
                <template v-slot:cell(chezvous)="data">
                  <span v-if="data.item.reception == 'creancier'"
                    >{{ data.item.montant }} €</span
                  >
                </template>
                <template v-slot:cell(actions)="data">
                  <template v-if="data.item.invoiced != 'Yes'">
                    <b-button
                      variant="success"
                      @click="editPayment(data.item)"
                      title="Éditer"
                      size="sm"
                      class="btn-xs"
                      icon
                    >
                      <b-icon-pencil-square></b-icon-pencil-square>
                    </b-button>
                    <b-button
                      v-if="$store.getters.isSuperAdmin"
                      variant="danger"
                      @click="deletePayment(data.item)"
                      title="Supprimer"
                      size="sm"
                      class="btn-xs ml-2"
                      icon
                    >
                      <b-icon-x-circle-fill></b-icon-x-circle-fill>
                    </b-button>
                  </template>
                  <span v-else><i>Facturé</i></span>
                </template>
              </list>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      id="modal-modifier-paiement"
      title="Modifier un paiement"
      hide-footer
    >
      <WarrantPayment
        @change="this.submitSearch()"
        @close="$bvModal.hide('modal-modifier-paiement')"
        :payment_id="payment_id"
        :warrant_id="warrant_id"
      ></WarrantPayment>
    </b-modal>
  </div>
</template>

<script>
import List from "@/components/List";
import MhInput from "@/components/MhInput";
import payments from "@/services/payments.js";
import DateTime from "@/services/DateTime.js";
import String from "@/services/String.js";
import WarrantPayment from "@/components/WarrantPayment";
export default {
  components: {
    List,
    MhInput,
    WarrantPayment,
  },
  name: 'payments',
  payments: [],
  data() {
    return {
      searchTable: {
        status: {
          label: "",
          type: "enum",
          value: "not-invoiced",
          options: [
            {
              value: "not-invoiced",
              text: "Non facturés",
            },
            {
              value: "invoiced",
              text: "Facturés",
            },
            {
              value: "all",
              text: "Tous les paiements",
            },
          ],
        },
        base: {
          label: "",
          type: "enum",
          value: "encodage",
          options: [
            {
              value: "encodage",
              text: "Date d'encodage",
            },
            {
              value: "paiement",
              text: "Date de paiement",
            },
          ],
        },
        search: {
          label: "",
          type: "varchar",
          value: "",
        },
      },
      defaultFilter: true,
      debug: false,
      info: {},
      search: this.$route.params.search || "",
      facets: [],
      filters: [],
      total: {},
      page: 1,
      payment_id: null,
      warrant_id: null,
      pagination: {},
      resultsInfo: "",
      loaded: true,
      busy: false,
      sortBy: "date",
      sortDesc: true,
      actions: [
        {
          label: "Éditer",
          to: "paymentView",
        },
      ],
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Paiements",
          active: true,
        },
      ],
      fields: [
        {
          key: "mandatID",
          label: "N° de mandat",
          sortable: true,
          class: "text-right",
          thStyle: { width: "5%" },
        },
        {
          key: "debiteur",
          label: "Débiteur",
          sortable: true,
          thStyle: { width: "10%" },
        },
        {
          key: "creancier",
          label: "Créancier",
          sortable: true,
          thStyle: { width: "10%" },
        },
        {
          key: "type",
          label: "Type",
          sortable: true,
        },
        { key: "date", label: "Date", sortable: true, class: "text-center" },
        {
          key: "date_encodage",
          label: "Date d'encodage",
          class: "text-center",
          sortable: true,
        },
        {
          key: "cheznous",
          label: "Chez nous",
          sortable: true,
          class: "text-right font-weight-bold",
        },
        {
          key: "chezvous",
          label: "Chez le créancier",
          sortable: true,
          class: "text-right font-weight-bold",
        },
        {
          key: "compte_societe",
          label: "Compte crédité",
          sortable: true,
        },
        {
          key: "compte_debiteur",
          label: "Compte débité",
          sortable: true,
        },
        {
          key: "numero_extrait",
          label: "Extrait",
          sortable: false,
          class: "text-truncate",
        },
        {
          key: "reception",
          label: "Réception",
          sortable: true,
          formatter: (val) => {
            if (val == "creancier") {
              return "Créancier";
            }
            return "Société";
          },
        },
        {
          key: "negotiateur",
          label: "Négotiateur",
          sortable: true,
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          thStyle: "width:100px",
        },
      ],
    };
  },
  created() {
    this.search = this.$route.params.search || "";
    this.scroll();
    this.loaded = false;
    this.submitSearch();
  },

  methods: {
    scroll() {
      window.onscroll = () => {
        let bottomOfWindow =
          document.documentElement.scrollTop + window.innerHeight + 300 >
          document.documentElement.offsetHeight;
        if (bottomOfWindow && this.pagination.numberOfPages > this.page && !this.busy) {
          this.page++;
          this.continueSearch();
        }
      };
    },
    editPayment(item) {
      this.warrant_id = item.mandatID;
      this.payment_id = item.ID;
      this.$bvModal.show("modal-modifier-paiement");
    },
    fullName(a, b) {
      return String.fullName(a, b);
    },
    ucfirst(a) {
      return String.ucfirst(a);
    },
    company(a) {
      return String.company(a);
    },
    toDate(d) {
      return DateTime.shortDate(d);
    },
    twoDigits(value) {
      return Number(value).toFixed(2);
    },
    reinit() {
      this.page = 1;
      this.filters = [];
      return true;
    },
    changeSort(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      this.submitSearch();
    },
    changePage(page) {
      this.page = page;
      this.submitSearch(false);
    },
    removeFilter(index) {
      this.filters.splice(index, 1);
      this.submitSearch();
    },
    narrow(object) {
      this.filters.push(object);
      this.submitSearch();
    },
   
    deletePayment(id) {
      payments.delete(id).then((response) => {
        this.$bvToast.toast(response.data.message, {
          title: `Recuperator`,
          toaster: "b-toaster-top-right",
          variant: "success",
          autoHideDelay: 2000,
          solid: false,
        });
        this.submitSearch();
      });
    },
    continueSearch() {
      this.busy = true;
      payments
        .search(
          this.searchTable.search.value,
          this.searchTable.status.value,
          this.searchTable.base.value,
          this.filters,
          "",
          this.page,
          this.sortBy,
          this.sortDesc
        )
        .then((response) => {
          this.$options.payments = this.$options.payments.concat(response.data.results.records);
          this.pagination = response.data.results.pagination;
          this.busy = false;
        })
        .catch(() => {
          this.busy = false;
        }); 
    },
    submitSearch() {
      this.busy = true;

      payments
        .search_old(
          this.searchTable.search.value,
          this.searchTable.status.value,
          this.searchTable.base.value,
          this.filters,
          "",
          this.page,
          this.sortBy,
          this.sortDesc
        )
        .then((response) => {
          this.$options.payments = response.data.results.records;
          this.pagination = response.data.results.pagination;
          this.resultsInfo = this.pagination.totalRecords;
          this.total = response.data.total;
          this.loaded = true;
          this.busy = false;
        })
        .catch(() => {
          this.loaded = true;
          this.busy = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>